/**
 * Notification Context - Toast notifications
 */
import { createContext, useState, useCallback, useContext } from 'react'

export const NotificationContext = createContext(null)

let notificationId = 0

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([])

  const addNotification = useCallback((message, type = 'info') => {
    const id = ++notificationId
    setNotifications((prev) => [...prev, { id, message, type }])
    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id))
    }, 3000)
    return id
  }, [])

  const removeNotification = useCallback((id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id))
  }, [])

  const showSuccess = useCallback((msg) => addNotification(msg, 'success'), [addNotification])
  const showError = useCallback((msg) => addNotification(msg, 'error'), [addNotification])
  const showWarning = useCallback((msg) => addNotification(msg, 'warning'), [addNotification])
  const showInfo = useCallback((msg) => addNotification(msg, 'info'), [addNotification])

  const value = {
    notifications,
    addNotification,
    removeNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  }

  return (
    <NotificationContext.Provider value={value}>
      {children}
      {/* Toast Container */}
      <div className="notification-container">
        {notifications.map((n) => (
          <div key={n.id} className={`notification notification-${n.type}`}>
            <div className="notification-content">
              <i className={`fas ${
                n.type === 'success' ? 'fa-check-circle' :
                n.type === 'error' ? 'fa-times-circle' :
                n.type === 'warning' ? 'fa-exclamation-triangle' :
                'fa-info-circle'
              }`} />
              <span>{n.message}</span>
            </div>
            <button className="notification-close" onClick={() => removeNotification(n.id)}>
              <i className="fas fa-times" />
            </button>
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  )
}

/**
 * Hook customizado para notificações
 */
export function useNotification() {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider')
  }
  return context
}
